import { default as bemCssModules } from 'bem-css-modules';
import { default as PopupHeaderStyles } from './PopupHeader.module.css';
import React from 'react';
const style = bemCssModules(PopupHeaderStyles);
export const PopupHeader = (props) => (React.createElement("p", { className: style() }, props.title));
